import React from "react";
import PropTypes from "prop-types";

import {
  DialogTitle,
  Dialog,
  IconButton,
  withStyles
} from "@material-ui/core/";
import CloseIcon from "@material-ui/icons/Close";

import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import CameraComponentStyle from "./CameraComponentStyle";
const CameraComponent = props => {
  const { handleDisplayCamera, setFieldValue, open, classes } = props;
  return (
    <Dialog open={open}>
      <DialogTitle>
        Say cheeeeeeeeese !
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={handleDisplayCamera}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Camera
        onTakePhoto={dataUri => {
          handleDisplayCamera();
          setFieldValue("photo", dataUri);
        }}
      />
    </Dialog>
  );
};

CameraComponent.propTypes = {
  open: PropTypes.bool,
  handleDisplayCamera: PropTypes.func,
  setFieldValue: PropTypes.func,
  classes: PropTypes.object
};

export default withStyles(CameraComponentStyle)(CameraComponent);
